
<div class="filters-container">

  <section class="filter-sections">

    <!-- Date Range -->
    <section class="filter-section">
      <h4>Date Range</h4>
      <div class="date-shortcuts">
        <button (click)="setDateRange(7)" [class.active]="isDateRangeActive(7)">Last 7 days</button>
        <button (click)="setDateRange(30)" [class.active]="isDateRangeActive(30)">Last 30 days</button>
        <button (click)="setDateRange(90)" [class.active]="isDateRangeActive(90)">Last 90 days</button>
      </div>
      <div class="date-inputs">
        <input type="date"
               [ngModel]="dateFrom()"
               (ngModelChange)="onDateFromChange($event)"
               placeholder="From" />
        <input type="date"
               [ngModel]="dateTo()"
               (ngModelChange)="onDateToChange($event)"
               placeholder="To" />
      </div>
    </section>

    <!-- Senders -->
    @if (facets?.senders?.length) {
    <section _ngcontent-ng-c63444268="" class="filter-section">
      <div class="spacer"></div>
    </section>

    <section class="filter-section">
      <h4>From</h4>
      <ul class="facet-list">
        @for (sender of facets!.senders.slice(0, showAllSenders() ? undefined : 5); track sender.value) {
        <li [class.selected]="selectedSender() === sender.value"
            (click)="onSenderClick(sender.value)">
          <span class="facet-value">{{ sender.value }}</span>
          <span class="facet-count">{{ sender.count }}</span>
        </li>
        }
      </ul>
      @if (facets!.senders.length > 5) {
      <button class="btn-show-more" (click)="showAllSenders.set(!showAllSenders())">
        {{ showAllSenders() ? 'Show less' : 'Show more' }}
      </button>
      }
    </section>
    }

    <section _ngcontent-ng-c63444268="" class="filter-section">
      <div class="spacer"></div>
    </section>

    <!-- Attachments -->
    <section class="filter-section">
      <h4>Attachments</h4>
      <label class="checkbox-label">
        <input type="checkbox"
               [ngModel]="activeFilters.hasAttachments"
               [checked]="hasAttachments()"
               (change)="onHasAttachmentsChange()" />
        Has attachments only
      </label>
    </section>

    <!-- Attachment Types -->
    @if (facets?.attachmentTypes?.length) {

    <section _ngcontent-ng-c63444268="" class="filter-section">
      <div class="spacer"></div>
    </section>

    <section class="filter-section">
      <h4>Attachment Types</h4>
      <ul class="facet-list">
        @for (type of facets!.attachmentTypes; track type.value) {
        <li [class.selected]="selectedAttachmentTypes().includes(type.value)"
            (click)="onAttachmentTypeClick(type.value)">
          <span class="facet-value">{{ type.value }}</span>
          <span class="facet-count">{{ type.count }}</span>
        </li>
        }
      </ul>
    </section>
    }
  </section>

  <section _ngcontent-ng-c63444268="" class="filter-section">
    <div class="spacer"></div>
  </section>

  <div class="filter-section" style="align-content: center;">
    <button class="btn-clear" (click)="onClearAll()">Clear all</button>
  </div>
</div>
